var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-button graphs",class:{
    active: _vm.tabIsOpened,
    unactive: !_vm.tabIsOpened
  },on:{"click":function($event){return _vm.openTab(_vm.tabClass)}}},[_vm._m(0),_c('OptionsList',{attrs:{"optionsList":_vm.graphsList}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"graphs-button"},[_vm._v(" Graphs "),_c('span',{staticClass:"icon"})])}]

export { render, staticRenderFns }